import React from 'react';
import InlineSVG from 'svg-inline-react';
import classNames from 'classnames';
import get from 'lodash.get';

import { useAppConfigContext } from '../../common/contexts/AppConfigContext';
import { EDITIONS } from '../../constants/applications';
import mclass from '../../assets/images/mclass.svg';
import mclassTexas from '../../assets/images/mclass-texas.svg';

const logoMap = {
    [EDITIONS.MCLASS_TX_EDITION]: mclassTexas,
};

export default () => {
    const { edition } = useAppConfigContext();
    const logoClassNames = classNames('dashboard-logo', {
        'dashboard-logo-branded': edition,
    });
    return <InlineSVG className={logoClassNames} src={get(logoMap, edition, mclass)} />;
};
